<template>
    <div
        class="relative min-h-[100px] rounded-lg border border-gray-200 bg-white"
    >
        <p class="mt-5 text-center text-xl font-bold">{{ $t('referrers.gallery-title') }}</p>
        <v-carousel
            v-model="currentSlide"
            :show-arrows="false"
            hide-delimiters
            height="auto"
        >
            <v-carousel-item
                v-for="(review, i) in projects"
                :key="review"
                :value="i"
            >
                <div
                    class="grid lg:min-h-[320px] grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-20 p-8 lg:px-16 lg:py-8"
                >
                    <div class="flex flex-col justify-center">
                        <img
                            class="w-full h-full rounded-lg object-cover"
                            :src="review.image1"
                        />
                    </div>

                    <div>
                        <img
                            class="w-full h-full rounded-lg object-cover"
                            :src="review.image2"
                        />
                    </div>
                </div>
            </v-carousel-item>
        </v-carousel>

        <div class="flex justify-center items-center space-x-4 lg:space-x-0 py-5 lg:py-0">
            <button
                @click="prevSlide"
                class="flex justify-center items-center hover:bg-opacity-90 duration-100 lg:absolute top-1/2 -left-6 -mt-6 h-10 w-10 lg:h-12 lg:w-12 rounded-full border bg-[#399ADB]"
            >
                <img
                    src="/images/campaigns/carousel-left-arrow.svg"
                    class="mr-1"
                    alt="Carousel left arrow"
                />
            </button>

            <button
                @click="nextSlide"
                class="flex justify-center items-center hover:bg-opacity-90 duration-100 lg:absolute top-1/2 -right-6 -mt-6 h-10 w-10 lg:h-12 lg:w-12 rounded-full border bg-[#399ADB]"
            >
                <img
                    src="/images/campaigns/carousel-right-arrow.svg"
                    class="ml-1"
                    alt="Carousel right arrow"
                />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name:'ImagesCarousel',
    data() {
        return {
            currentSlide: 0,
        };
    },
    computed: {
        projects() {
            const locale = process.env.MIX_APP_LOCALE || "pl";

            return [
                {
                    image1: `/images/raf/${locale}/1.webp`,
                    image2: `/images/raf/${locale}/2.webp`,
                },
                {
                    image1: `/images/raf/${locale}/3.webp`,
                    image2: `/images/raf/${locale}/4.webp`,
                },
                {
                    image1: `/images/raf/${locale}/5.webp`,
                    image2: `/images/raf/${locale}/6.webp`,
                },
                {
                    image1: `/images/raf/${locale}/7.webp`,
                    image2: `/images/raf/${locale}/8.webp`,
                },
                {
                    image1: `/images/raf/${locale}/9.webp`,
                    image2: `/images/raf/${locale}/10.webp`,
                },
            ]
        },
    },
    methods: {
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.projects.length;
        },
        prevSlide() {
            if (this.currentSlide === 0) {
                this.currentSlide = this.projects.length - 1;
            } else {
                this.currentSlide =
                    (this.currentSlide - 1) % this.projects.length;
            }
        },
    },
};
</script>
